export enum CookieEnum {
  Token = 'token',
  RefreshToken = 'refreshToken',
  User = 'user',
  GPToken = 'gptoken',
  Layout = 'layout',
}
